// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Untey","tabs":"Form_tabs__M3i4u","tabWithoutErrors":"Form_tabWithoutErrors__NOkgR","tabWithErrors":"Form_tabWithErrors__FmNsk"};